import { Satellite, Power, Fuel, Gauge, Thermometer, Wrench } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import SectionHeading from '@/components/SectionHeading';
import { Stagger, StaggerItem } from '@/components/Reveal';

const ICONS = [Satellite, Power, Fuel, Gauge, Thermometer, Wrench];
const SPANS = ['md:col-span-4', 'md:col-span-2', 'md:col-span-2', 'md:col-span-4', 'md:col-span-3', 'md:col-span-3'];

function OrbitViz() {
  return (
    <svg viewBox="0 0 220 120" className="mt-6 h-28 w-full" aria-hidden="true">
      <ellipse cx="110" cy="60" rx="92" ry="34" fill="none" stroke="#0052FF" strokeOpacity="0.25" strokeWidth="1.5" />
      <ellipse cx="110" cy="60" rx="60" ry="20" fill="none" stroke="#0EA5E9" strokeOpacity="0.35" strokeWidth="1.5" strokeDasharray="4 5" />
      <circle cx="110" cy="60" r="14" fill="#0052FF" opacity="0.12" />
      <circle cx="110" cy="60" r="6" fill="#0052FF" />
      <circle cx="30" cy="82" r="5" fill="#0EA5E9"><animateMotion dur="7s" repeatCount="indefinite" path="M30 82 A92 34 0 1 0 190 82 A92 34 0 1 0 30 82" /></circle>
      <circle cx="170" cy="52" r="4" fill="#0052FF"><animateMotion dur="5s" repeatCount="indefinite" path="M170 52 A60 20 0 1 0 50 52 A60 20 0 1 0 170 52" /></circle>
    </svg>
  );
}

export default function BentoGrid() {
  const { t } = useLanguage();
  const items = t('bento.items');
  return (
    <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8" data-testid="bento-section">
      <SectionHeading eyebrow="bento.eyebrow" title="bento.title" sub="bento.sub" align="center" />
      <Stagger className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-6" gap={0.09}>
        {items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <StaggerItem key={item.title} className={SPANS[i]}>
              <div className="card-hover flex h-full flex-col rounded-2xl border border-brand-line bg-white p-6" data-testid={`bento-card-${i}`}>
                <div className="flex items-center justify-between">
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-blue/8 text-brand-blue border border-brand-blue/15">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-mono text-[10px] font-semibold uppercase tracking-widest text-brand-dim">{item.tag}</span>
                </div>
                <h3 className="mt-5 font-display text-lg font-bold text-brand-ink">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-steel">{item.desc}</p>
                {i === 0 && <OrbitViz />}
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </section>
  );
}
